import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { IAppSlide } from 'src/app/interfaces/book-store';
import { AddNewAndTrendingComponent } from '../add-new-and-trending/add-new-and-trending.component';

@Component({
  selector: 'app-new-and-trending',
  templateUrl: './new-and-trending.component.html',
  styleUrls: ['./new-and-trending.component.scss']
})
export class NewAndTrendingComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.APP_SLIDE;
  DISPLAY_STATUS_KEY: any;
  COLLECTION: any;

  TITLE: any;
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public store: BookstoreStore,
    private route: ActivatedRoute,
    private storage: FireStorageService
  ) { }

  ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    this.route.params.subscribe(params => {
      const { id } = params;
      switch (id) {
        case "new_and_trending":
          this.tabs = TESTING_CENTER.APP_NEW_AND_TRENDING;
          this.TITLE = "New & Trending";
          this.COLLECTION = COLLECTION_NAME.APP_NEW_AND_TRENDING;
          break;
        case "top_charts":
          this.tabs = TESTING_CENTER.APP_TOP_CHARTS;
          this.TITLE = "Top Charts";
          this.COLLECTION = COLLECTION_NAME.APP_TOP_CHARTS;
          break;
        case "special_offers_and_free":
          this.tabs = TESTING_CENTER.APP_SPECIAL_OFFERS_AND_FREE;
          this.TITLE = "Special Offers and Free";
          this.COLLECTION = COLLECTION_NAME.APP_SPECIAL_OFFERS_AND_FREE;
          break;
        default:
          this.tabs = TESTING_CENTER.APP_BOOKS_WE_LOVE;
          this.TITLE = "Books We Love";
          this.COLLECTION = COLLECTION_NAME.APP_BOOKS_WE_LOVE;
          break;
      }
      this.store.fetchData(this.COLLECTION, this.DISPLAY_STATUS_KEY.key)
    })

  }



  create(item?: any) {
    let dialogRef = this.dialog.open(AddNewAndTrendingComponent, {
      data: { ITEM: item || null, COLLECTION: this.COLLECTION, TITLE: this.TITLE },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  delete(item: IAppSlide) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: `Delete ${this.TITLE}`,
        memo: `${this.TITLE} will permanently drop from app.`,
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        if (item.fileDetail) {
          await this.storage.storageRef(item.fileDetail.filename).delete().toPromise();
        }
        this.store.deleteItem(this.COLLECTION, item, (success, error) => {
          if (success) {
            this.snackBar.open(`${this.TITLE} has been deleted.`, 'done', { duration: 2000 });
            this.store.fetchData(this.COLLECTION, this.DISPLAY_STATUS_KEY.key)
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }

}
